import { useEffect, useRef } from 'react'
import { Loader2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

interface Props {
    hasMore: boolean
    loadingMore: boolean
    onLoadMore: () => void
}

/** Cuối danh sách phân trang: cuộn tới thì tự tải trang sau (kèm nút bấm tay). */
export function LoadMoreSentinel({ hasMore, loadingMore, onLoadMore }: Props) {
    const sentinel = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const el = sentinel.current
        if (!el || !hasMore || typeof IntersectionObserver === 'undefined')
            return
        const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting) && !loadingMore)
                onLoadMore()
        })
        io.observe(el)
        return () => io.disconnect()
    }, [hasMore, loadingMore, onLoadMore])

    if (!hasMore) return null
    return (
        <div ref={sentinel} className="flex justify-center">
            <Button
                type="button"
                variant="outline"
                size="sm"
                disabled={loadingMore}
                onClick={onLoadMore}
            >
                {loadingMore && <Loader2 className="size-4 animate-spin" />}
                {m.media_load_more()}
            </Button>
        </div>
    )
}
